import { Config } from "../../configurations/config";
export const MyTimeSheetStatus_API = {
  GetMyTimeSheetStatusList: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetTimesheet`,
  ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/ExportToExcel`,
};
